export const AGENT_PROFILE_PATH = '/agent-profile';
export const AGENT_PROFILE_TITLE = 'agentProfile.ap_agent_profile_title';
export const AGENT_PROFILE_NAMESPACE = 'agent-profile';
